import React, { useEffect, SetStateAction, Dispatch } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faDiscord } from "@fortawesome/free-brands-svg-icons";
import LoadingContent from "../../LoadingContent";
import { countryCodeToFlag } from "../../../utils/Admin";

interface DiscordProps {
  data: any;
  discordTitle: string;
  setDiscordTitle: Dispatch<SetStateAction<string>>;
  discordEmbed: string;
  setDiscordEmbed: Dispatch<SetStateAction<string>>;
  onIndividualSubmit: () => void; // Prop para envío 1 a 1
  uploading: boolean; // Prop para el spinner individual
}

const NewsDiscord = ({
  data,
  discordTitle,
  setDiscordTitle,
  discordEmbed,
  setDiscordEmbed,
  onIndividualSubmit,
  uploading,
}: DiscordProps) => {
  useEffect(() => {
    if (!data) return;

    setDiscordTitle(`🗞️ **${data.news.title_en.toUpperCase()}**`);
    setDiscordEmbed(
      [
        `_${data.news.caption_en}_\n`,
        "",
        `🇬🇧 English: ${data.reportLinkEn}`,
        `🇪🇸 Español: ${data.reportLinkEs}`,
        data.entriesText,
        data.youtube != null
          ? `\n📹https://www.youtube.com/watch?v=${data.youtube}`
          : ``,
      ]
        .filter(Boolean)
        .join("\n"),
    );
  }, [data, setDiscordTitle, setDiscordEmbed]);

  if (data == null) return <LoadingContent />;

  return (
    // Reemplazamos <Form> por un <div> plano para integrarlo en el padre
    <div className="discord-form mb-4 p-3 border rounded shadow-sm">
      <Row className="mb-3">
        <Form.Group className="form-group col-md-12">
          <h4>
            <FontAwesomeIcon
              icon={faDiscord}
              className="me-2"
              style={{ color: "#5865F2" }}
            />
            Discord [including @Role + News Image]
          </h4>
          <Form.Label>Title (*)</Form.Label>
          <Form.Control
            required
            name="discord_title"
            type="text"
            value={discordTitle}
            onChange={(e) => setDiscordTitle(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="form-group" as={Col} md="12">
          <Form.Label>Embed (*)</Form.Label>
          <Form.Control
            required
            as="textarea"
            name="discord_embed"
            rows={6}
            value={discordEmbed}
            onChange={(e) => setDiscordEmbed(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Field required
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Botón exclusivo para enviar únicamente a Discord */}
      <div className="text-center">
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner-button" spin />
        ) : (
          <Button
            type="button" // Evita que se dispare el submit global del componente padre
            variant="secondary"
            onClick={onIndividualSubmit}
          >
            Send Discord Message Only
          </Button>
        )}
      </div>
    </div>
  );
};

export default NewsDiscord;
